import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
// import MenuIcon from "@material-ui/icons/Menu";
// import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import ImageToko from "../../../assets/logo-tokorame.svg";
import { Container } from "@material-ui/core";
// import { auth } from "../../firebase/FirebaseProvider";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    // marginRight: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  title: {
    flexGrow: 1,
    color: "#000",
    marginLeft: -40,
    fontWeight: 'normal'
  },
  link: {
    color: '#537ED4',
    textDecoration: 'none',
    '&:hover': {
      color: '#3333B0'
    },
    [theme.breakpoints.up('460')]: {
      fontSize: 12

    }
  },
}));
export default function ButtonAppBar(nameStatus) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('tablet'));
  const matches1 = useMediaQuery(theme.breakpoints.up('537'));

  // const logout = () => {
  //   auth.signOut();
  // };
  return (
    <div className={classes.root}>

      <AppBar position="static" style={{ backgroundColor: "#fff" }}>
        <Container>
          {matches ?
            <Toolbar>
              <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="menu"
              // disabled={true}
              // onClick={logout}
              >
                <img src={ImageToko} alt="Toko" style={{ width: "70%", height: "100%" }} />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Daftar
              </Typography>
              <Link onClick={() => window.open(`https://play.google.com/store/apps/details?id=com.tokorame.resellerapp`)} className={classes.link}>
                Download Aplikasi Tokorame
              </Link>
            </Toolbar>
            :
            <Toolbar>
              <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="menu"
                disableTouchRipple={true}
                disabled={true}
              >
                <div style={{ width: "100%", display: 'flex' }}>
                  {/* <ArrowBackIosIcon /> */}
                  <img src={ImageToko} alt="Toko" style={{ width: "50%", height: "100%", marginLeft: 0 }} />
                  <text name="hy" style={{ fontSize: 14, position: 'absolute', marginLeft: "50%", marginTop: 10 }}>{nameStatus.nameStatus}
                  </text>
                </div>
              </IconButton>
              {matches1 ?
                <div style={{ display: 'flex', width: "100%" }}>
                  <Link onClick={() => window.open(`https://play.google.com/store/apps/details?id=com.tokorame.resellerapp`)} className={classes.link}>
                    Download Aplikasi Tokorame
                  </Link>
                </div>
                : null}

            </Toolbar>
          }
        </Container>
      </AppBar>
    </div>
  );
}